module.exports = __webpack_public_path__ + "img/novelty-pic.77d9d4dd.png";